<div>
  <h2 style="margin: 2%; text-align: center;">In 24h zum fertigen Kaufvertrag! </h2>
  <div class="custom-top-head-line" style="padding:5px;">
    Der Prozess gliedert sich in folgende Schritte:
    <ul>
      <li>
        Erfassung Stammdaten Käufer und Verkäufer
      </li>
      <li>
        Erfassung Liegenschaftsdaten
      </li>
      <li>
        Übermittlung der Daten an die Mähr Rechtsanwalt GmbH zur weiteren Verarbeitung
      </li>

    </ul>

    Die Errichtungskosten des Vertrages samt grundbücherlicher Durchführung betragen Netto 0,8% des Kaufpreises, jedoch
    mindestens 2.500,00 € Netto.<br>
    Die Mähr Rechtsanwalt GmbH garantiert die Übermittlung des Vertragsentwurfes samt Informationsschreiben innert von
    24h
    an Arbeitstagen, ansonsten erfolgt die Vertragserrichtung kostenlos.
    <br>
    <br>
    Die Vertragserrichtung ist derzeit nur für österreichische Liegenschaften möglich.
    <br>
  </div>
  <div class="custom-weiter-div">
    <button mat-raised-button color="Fprimary" class="custom-weiter" (click)="gotoMasterData()">
      Start
    </button>
    <label style="float: right;">
      <fa-icon class="accent-color custom-weiter" [icon]="faArrowRight"></fa-icon>
    </label>
  </div>
  <br>
  <br>
  <br>
  <br>
</div>